import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const PERSIST_APPLIED_FILTERS_TOKEN = new InjectionToken<(id: number, placeholders: Record<string, any>) => Observable<void>>(
    'Provide function to persist applied filters'
);
